import { ActionTree } from 'vuex/types/index'

import { RootState } from '~/store/store.types'
import { SohoModel } from '~/constants/SohoModel'
import { RequestParameters } from '~/utils/SohoApi/SohoApi'
import { setIncludedResources } from '~/utils/store'

import { PerksState, PerkResource, Perk, PerksFilter } from './perks.types'

const actions: ActionTree<PerksState, RootState> = {
  async fetchPerks ({ commit }, params: RequestParameters<Perk, PerksFilter> = {}) {

    const { data, included } = await this.$sohoApi.get<PerkResource>(SohoModel.Perk, params)

    // Optionally set the included resources
    if (included) {
      setIncludedResources(included, commit)
    }

    commit('SET_PERKS', { params, data })
  },

  async fetchPerk ({ commit }, id) {
    const { data, included } = await this.$sohoApi.get<PerkResource>(`${SohoModel.Perk}/${id}`)

    // Optionally set the included resources
    if (included) {
      setIncludedResources(included, commit)
    }

    commit('SET_PERK', data)
  }
}


export default actions
